import React from "react";
// import { lazy } from 'react';
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "register",
    path: `${AUTH_PREFIX_PATH}/register`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/register")
    ),
  },
  {
    key: "pdf",
    path: `${AUTH_PREFIX_PATH}/pdf/:data`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/Showpdf")
    ),
  },
  {
    key: "resettrequest",
    path: `${AUTH_PREFIX_PATH}/resetRequest`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ResetPasswordRequest")
    ),
  },
  {
    key: "reset",
    path: `${AUTH_PREFIX_PATH}/reset/:token`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ResetPassword")
    ),
  },
  // {
  //     key: 'demo',
  //     path: `${AUTH_PREFIX_PATH}/pdf/:data`,
  //     component: React.lazy(() => import('views/app-views/dashboards/invoiceStatus/Showpdf')),
  // },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/Station`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/mic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/default/Mic")
    ),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/ZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/default/ZIC")
    ),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/Admin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/default/Admin")
    ),
  },
  {
    key: "MIB.AddNew",
    path: `${APP_PREFIX_PATH}/ZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddNewZic")
    ),
  },
  {
    key: "MIB.AddNew",
    path: `${APP_PREFIX_PATH}/MIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddNewMic")
    ),
  },
  {
    key: "MIB.AddNewStationProfile",
    path: `${APP_PREFIX_PATH}/StationProfile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddStattionProfile")
    ),
  },
  {
    key: "ManPowerCompliance",
    path: `${APP_PREFIX_PATH}/manpowercompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/manpowercompliance/ManPowerCompliance")
    ),
  },
  {
    key: "RetailCompliance",
    path: `${APP_PREFIX_PATH}/retailcompliance`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/retailOutLetCompliance/RetailOutLetCompliance"
      )
    ),
  },
  {
    key: "RecordCollection",
    path: `${APP_PREFIX_PATH}/recordcollection`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/recoedcollection/RecordCollection")
    ),
  },
  {
    key: "invoice status",
    path: `${APP_PREFIX_PATH}/invoicestatus`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/InvoiceStatus")
    ),
  },
  {
    key: "Compliance",
    path: `${APP_PREFIX_PATH}/compliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/compliance/Compliance")
    ),
  },

  {
    key: "ActivityCalendar",
    path: `${APP_PREFIX_PATH}/activityCalendar`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/ActivityCalendar")
    ),
  },
  {
    key: "NewScheme",
    path: `${APP_PREFIX_PATH}/addnewscheme`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/NewScheme")
    ),
  },
  {
    key: "complain",
    path: `${APP_PREFIX_PATH}/complain`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/Complain")
    ),
  },
  {
    key: "complainForMic",
    path: `${APP_PREFIX_PATH}/mic/complain`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/ComplainForMIC")
    ),
  },
  // {
  //   key: "techComplaintForMic",
  //   path: `${APP_PREFIX_PATH}/mic/techcomplain`,
  //   component: React.lazy(() =>
  //     import(
  //       "views/app-views/dashboards/TechComplaintForMic/TechComplaintForMic"
  //     )
  //   ),
  // },
  {
    key: "roaudit",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAudit")
    ),
  },
  {
    key: "roauditMAin",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits/:rowid`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAuditMain")
    ),
  },

  {
    key: "dispenser",
    path: `${APP_PREFIX_PATH}/docs/documentation/em/dispenser`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/equipmentManagement/DispenserWise")
    ),
  },
  {
    key: "compressor",
    path: `${APP_PREFIX_PATH}/docs/documentation/em/compressor`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/equipmentManagement/CompressorWise")
    ),
  },
  {
    Key: "generateCommsissionInvoice",
    path: `${APP_PREFIX_PATH}/generateinvoice`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/CommissionInvoise")
    ),
  },
  {
    Key: "schemesForAdmin",
    path: `${APP_PREFIX_PATH}/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemeForAdmin")
    ),
  },
  {
    Key: "schemesForUser",
    path: `${APP_PREFIX_PATH}/user/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemForUser")
    ),
  },
  {
    ket: "stc",
    path: `${APP_PREFIX_PATH}/mic/stc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/stc/STCforMIC")
    ),
  },
  {
    key: "NotFound",
    path: `${APP_PREFIX_PATH}/NotFound`,
    component: React.lazy(() => import("views/app-views/dashboards/NotFound")),
  },
];

export const zicRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/ZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newDefaultForZIC/DefaultForZIC")
    ),
  },
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newDefaultForZIC/DefaultForZIC")
    ),
  },
    {
    key: "price",
    path: `${APP_PREFIX_PATH}/update-price`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/Updateprice")
    ),
    
  },
  {
    key: "commission-update",
    path: `${APP_PREFIX_PATH}/commission-update`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/CommissionUpdate")
    ),
    
  },
  // {
  //   key: "mic-mapping",
  //   path: `${APP_PREFIX_PATH}/mic-mapping`,
  //   component: React.lazy(() =>
  //     import("views/app-views/dashboards/users/MicMapping")
  //   ),
    
  // },
  // {
  //     key: 'dashboard.default',
  //     path: `${APP_PREFIX_PATH}`,
  //     component: React.lazy(() => import('views/app-views/dashboards/default/ZIC')),
  // },
  {
    key: "MIB.AddNew",
    path: `${APP_PREFIX_PATH}/MIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddNewMic")
    ),
  },
  {
    key: "schemesForUser",
    path: `${APP_PREFIX_PATH}/user/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemForUser")
    ),
  },
  {
    key: "RoAuditTarget",
    path: `${APP_PREFIX_PATH}/ZIC/RoAuditTarget`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/auditTagetZic/AuditTargetByZic")
    ),
  },
  {
    key: "TechnicalComplZic",
    path: `${APP_PREFIX_PATH}/ZIC/TechnicalComplZic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/TechComplaintforzic/TechnicalComplZic")
    ),
  },
  {
    key: "DryOutForZic",
    path: `${APP_PREFIX_PATH}/ZIC/DryOutForZic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/reportsForZic/DryOutForZic")
    ),
  },
  {
    key: "NonOperationForZic",
    path: `${APP_PREFIX_PATH}/ZIC/NonOperationForZic`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/NonOperationForZic"
      )
    ),
  },
  {
    key: "TechnicalComplaintZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/TechnicalComplaintZIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/TechnicalComplaintZIC"
      )
    ),
  },
  {
    key: "NotFound",
    path: `${APP_PREFIX_PATH}/NotFound`,
    component: React.lazy(() => import("views/app-views/dashboards/NotFound")),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
  {
    key: "reportsForZic",
    path: `${APP_PREFIX_PATH}/report/reportsForZic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/reportsForZic/reportForZIC")
    ),
  },

  {
    key: "AccountsZICReport",
    path: `${APP_PREFIX_PATH}/report/AccountsZICReport`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/AccountsZICReport"
      )
    ),
  },
  {
    key: "SaleReportZIC",
    path: `${APP_PREFIX_PATH}/report/SaleReportZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/reportsForZic/SaleReportZIC")
    ),
  },

  {
    key: "manpowercompliance",
    path: `${APP_PREFIX_PATH}/zic/manpowercompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/manpowercompliance/ManPowerForZIC")
    ),
  },
  {
    key: "retailcompliance",
    path: `${APP_PREFIX_PATH}/zic/retailcompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/retailOutLetCompliance/RoForZIC")
    ),
  },
  {
    key: "complaint",
    path: `${APP_PREFIX_PATH}/zic/complaint`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/NonTechComplaintForZIC")
    ),
  },
  {
    key: "stc",
    path: `${APP_PREFIX_PATH}/zic/stc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/stc/STCforStation")
    ),
  },
  {
    key: "BankGuaranteeZIC",
    path: `${APP_PREFIX_PATH}/zic/BankGuaranteeZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/bankGurantee/BankGuaranteeZIC")
    ),
  },
  {
    key: "activityCalender",
    path: `${APP_PREFIX_PATH}/zic/activityCalender`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/CalenderForZIC")
    ),
  },
  {
    key: "GrowthZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/GrowthZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/reportsForZic/GrowthZIC")
    ),
  },
  {
    key: "MarketShareReportZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/MarketShareReportZIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/MarketShareReportZIC"
      )
    ),
  },
  {
    key: "MarketShareReportZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/MarketShareReportZIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/MarketShareReportZIC"
      )
    ),
  },
  {
    key: "DaywiseSalesReportZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/DaywiseSalesReportZIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/DaywiseSalesReportZIC"
      )
    ),
  },
  {
    key: "MonthwiseSalesReportZIC",
    path: `${APP_PREFIX_PATH}/report/reportsForZic/MonthwiseSalesReportZIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/report/reportsForZic/MonthwiseSalesReportZIC"
      )
    ),
  },
  {
    key: "ManPowerComplianceZICReport",
    path: `${APP_PREFIX_PATH}/report/ManPowerComplianceZICReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManPowerComplianceMICReport")
    ),
  },
  {
    key: "ROComplianceReportZIC",
    path: `${APP_PREFIX_PATH}/report/ROComplianceReportZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ROComplianceReportMMIC")
    ),
  },
  {
    key: "ManningNorms",
    path: `${APP_PREFIX_PATH}/report/ManningNormsMic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManningNomsMic")
    ),
  },
  {
    key: "ManningNormsReports",
    path: `${APP_PREFIX_PATH}/report/ManningNormsMicReports`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManningNormsMICReports")
    ),
  },
];

export const stationRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/Station`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "MIB.AddNewStationProfile",
    path: `${APP_PREFIX_PATH}/StationProfile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddStattionProfile")
    ),
  },
  {
    key: "ManPowerCompliance",
    path: `${APP_PREFIX_PATH}/manpowercompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/manpowercompliance/ManPowerCompliance")
    ),
  },

  {
    key: "RetailCompliance",
    path: `${APP_PREFIX_PATH}/retailcompliance`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/retailOutLetCompliance/RetailOutLetCompliance"
      )
    ),
  },
  {
    key: "RecordCollection",
    path: `${APP_PREFIX_PATH}/recordcollection`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/recoedcollection/RecordCollection")
    ),
  },
  {
    key: "invoice status",
    path: `${APP_PREFIX_PATH}/invoicestatus`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/InvoiceStatus")
    ),
  },
  {
    key: "Compliance",
    path: `${APP_PREFIX_PATH}/compliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/compliance/Compliance")
    ),
  },
  {
    key: "roaudit",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAudit")
    ),
  },
  {
    key: "equipmentManagent",
    path: `${APP_PREFIX_PATH}/docs/documentation/em`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/equipmentManagement/Em")
    ),
  },
  // {
  //     key: 'compressor',
  //     path: `${APP_PREFIX_PATH}/docs/documentation/em/compressor`,
  //     component: React.lazy(() => import('views/app-views/dashboards/equipmentManagement/CompressorWise')),
  // },
  {
    key: "complain",
    path: `${APP_PREFIX_PATH}/complain`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/Complain")
    ),
  },
  {
    key: "Techcomplain",
    path: `${APP_PREFIX_PATH}/Techcomplain`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/TechnicalComplaint")
    ),
  },
  {
    key: "salesquantityreport",
    path: `${APP_PREFIX_PATH}/report/salesquantityreport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/SalesReport")
    ),
  },
  {
    key: "salesamountreport",
    path: `${APP_PREFIX_PATH}/report/salesamountreport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/SaleAmountReport")
    ),
  },
  {
    key: "generateCommsissionInvoice",
    path: `${APP_PREFIX_PATH}/generateinvoice`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/CommissionInvoise")
    ),
  },
  {
    key: "schemesForUser",
    path: `${APP_PREFIX_PATH}/user/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemForUser")
    ),
  },
  {
    key: "userProfile",
    path: `${APP_PREFIX_PATH}/user/profile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/ViewProfile")
    ),
  },
  {
    key: "STC Compliance",
    path: `${APP_PREFIX_PATH}/station/stc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/stc/STCforMIC")
    ),
  },
  {
    key: "NotFound",
    path: `${APP_PREFIX_PATH}/NotFound`,
    component: React.lazy(() => import("views/app-views/dashboards/NotFound")),
  },
  {
    key: "roauditMAin",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits/:rowid`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAuditMain")
    ),
  },
  {
    key: "roPenalty",
    path: `${APP_PREFIX_PATH}/docs/documentation/penalty`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/roPenalty/RoPenalty")
    ),
  },
  {
    key: "ActivityCalendar",
    path: `${APP_PREFIX_PATH}/activityCalendar/Calendar`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/CalenderForStation")
    ),
  },
  {
    key: "payment History",
    path: `${APP_PREFIX_PATH}/paymentHistory`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/payment/PaymentHistory")
    ),
  },
  {
    key: "report dryout",
    path: `${APP_PREFIX_PATH}/ReportDryout`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/dryout/Dryout")
    ),
  },
  {
    key: "bankGurantee",
    path: `${APP_PREFIX_PATH}/bankgurantee`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/bankGurantee/BankGurantee")
    ),
  },
  {
    key: "ManPowerComplianceReport",
    path: `${APP_PREFIX_PATH}/report/ManPowerComplianceReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/ManPowerComplianceReport")
    ),
  },

  {
    key: "STCNOC",
    path: `${APP_PREFIX_PATH}/stc/noc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/stc/StcNOC")
    ),
  },
  {
    key: "RetailOutletComplianceReport",
    path: `${APP_PREFIX_PATH}/report/RetailOutletComplianceReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/RetailOutletComplianceReport")
    ),
  },
  {
    key: "STCReport",
    path: `${APP_PREFIX_PATH}/report/STCReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/STCReport")
    ),
  },
  {
    key: "PaymentHistoryReport",
    path: `${APP_PREFIX_PATH}/report/PaymentHistoryReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/PaymentHistoryReport")
    ),
  },
  {
    key: "DryOutReport",
    path: `${APP_PREFIX_PATH}/report/DryOutReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/DryOutReport")
    ),
  },
  {
    key: "StationReportsPage",
    path: `${APP_PREFIX_PATH}/report/StationReportsPage`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/StationReportsPage")
    ),
  },
  {
    key: "customer",
    path: `${APP_PREFIX_PATH}/customer`,
    component: React.lazy(() => import("views/app-views/dashboards/Customer")),
  },
  {
    key: "CollectionReport",
    path: `${APP_PREFIX_PATH}/report/CollectionReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/CollectionReport")
    ),
  },
  {
    key: "TechnicalComplaintReport",
    path: `${APP_PREFIX_PATH}/report/TechnicalComplaintReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/TechnicalComplaintReport")
    ),
  },
  {
    key: "contact",
    path: `${APP_PREFIX_PATH}/contact`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/Contact")
    ),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
];

export const adminRoutes = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboards/Admin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/defaultForAdmin/DefaultForAdmin")
    ),
  },
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/defaultForAdmin/DefaultForAdmin")
    ),
  },
  {
    key: "MIB.AddNew",
    path: `${APP_PREFIX_PATH}/ZIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddNewZic")
    ),
  },
  {
    key: "MIB.AddNew",
    path: `${APP_PREFIX_PATH}/MIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddNewMic")
    ),
  },
  {
    key: "MIB.AddNewStationProfile",
    path: `${APP_PREFIX_PATH}/StationProfile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddStattionProfile")
    ),
  },
  {
    key: "ManPowerCompliance",
    path: `${APP_PREFIX_PATH}/manpowercompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/manpowercompliance/ManpowerComplianceHrir")
    ),
  },
  {
    key: "RetailCompliance",
    path: `${APP_PREFIX_PATH}/retailcompliance`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/retailOutLetCompliance/RetailOutLetCompliance"
      )
    ),
  },
  {
    key: "Compliance",
    path: `${APP_PREFIX_PATH}/compliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/compliance/Compliance")
    ),
  },
  {
    key: "roaudit",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAudit")
    ),
  },
  {
    key: "generateCommsissionInvoice",
    path: `${APP_PREFIX_PATH}/generateinvoice`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/invoiceStatus/CommissionInvoise")
    ),
  },
  {
    key: "schemesForAdmin",
    path: `${APP_PREFIX_PATH}/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemeForAdmin")
    ),
  },
  {
    key: "NotFound",
    path: `${APP_PREFIX_PATH}/NotFound`,
    component: React.lazy(() => import("views/app-views/dashboards/NotFound")),
  },
  {
    key: "ActivityCalendar",
    path: `${APP_PREFIX_PATH}/activityCalendar/Calendar`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/ActivityCalendar")
    ),
  },
  {
    key: "ActivityCalendar",
    path: `${APP_PREFIX_PATH}/activityCalendar`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/ActivityCalendar")
    ),
  },
  {
    key: "addevent",
    path: `${APP_PREFIX_PATH}/activityCalendar/AddEvent`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/AddEvent")
    ),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
  {
    key: "NonOperationForAdmin",
    path: `/${APP_PREFIX_PATH}/report/NonOperationForAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/NonOperationForAdmin")
    ),
  },
  {
    key: "ReportForAdmin",
    path: `/${APP_PREFIX_PATH}/report/Admin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/reportForAdmin")
    ),
  },
  {
    key: "NonOpROReport",
    path: `/${APP_PREFIX_PATH}/report/NonOperationForAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/NonOperationForAdmin")
    ),
  },
  {
    key: "AccountsAdminReport",
    path: `/${APP_PREFIX_PATH}/report/AccountsAdminReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/AccountsAdminReport")
    ),
  },
  {
    key: "SaleReportAdmin",
    path: `/${APP_PREFIX_PATH}/report/SaleReportAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/SaleReportAdmin")
    ),
  },
  {
    key: "TechnicalComplaintAdmin",
    path: `/${APP_PREFIX_PATH}/report/TechnicalComplaintAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/TechnicalComplaintAdmin"
      )
    ),
  },
  {
    key: "DryOutForAdmin",
    path: `/${APP_PREFIX_PATH}/report/DryOutForAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/DryOutForAdmin")
    ),
  },
  {
    key: "GrowthReport",
    path: `/${APP_PREFIX_PATH}/report/GrowthForAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/Growthadmin")
    ),
  },
  {
    key: "DaywiseSaleReport",
    path: `/${APP_PREFIX_PATH}/report/DaywisesaleReportAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/DaywiseSalesReportAdmin"
      )
    ),
  },
  {
    key: "ManPowerComplianceAdminReport",
    path: `/${APP_PREFIX_PATH}/report/ManPowerComplianceAdminReport`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/ManPowerComplianceAdminReport"
      )
    ),
  },
  {
    key: "MarketShareReportAdmin",
    path: `/${APP_PREFIX_PATH}/report/MarketShareReportAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/MarketShareReportAdmin"
      )
    ),
  },
  {
    key: "ManningNomsAdmin",
    path: `/${APP_PREFIX_PATH}/report/ManningNomsAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/ManningNomsAdmin")
    ),
  },
  {
    key: "acManningNomsAdmin",
    path: `/${APP_PREFIX_PATH}/report/ActualVsManningNomsAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManningNormsMICReports")
    ),
  },
  {
    key: "PointwiseSaleAdmin",
    path: `/${APP_PREFIX_PATH}/report/PointwiseSaleAdmin`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/reportsForAdmin/SaleReportAdmin")
    ),
  },
  {
    key: "MonthwiseSalesReportAdmin",
    path: `/${APP_PREFIX_PATH}/report/MonthwiseSalesReportAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/MonthwiseSalesReportAdmin"
      )
    ),
  },
  {
    key: "ROComplianceReportAdmin",
    path: `/${APP_PREFIX_PATH}/report/ROComplianceReportAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/micReport/ROComplianceReportMMIC"
      )
    ),
  },
  {
    key: "LoginLogsAdmin",
    path: `/${APP_PREFIX_PATH}/report/LoginLogsAdmin`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/LoginlogsReport"
      )
    ),
  },
];

export const micRoutes = [
  {
    key: "dashboard.mic1",
    path: `${APP_PREFIX_PATH}/dashboards/mic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/defaultForMIC/DefaultForMIC")
    ),
  },
  {
    key: "dashboard.mic",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/defaultForMIC/DefaultForMIC")
    ),
  },
  {
    key: "StationProfile",
    path: `${APP_PREFIX_PATH}/StationProfile`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddStattionProfile")
    ),
  },
  {
    key: "StationManager",
    path: `${APP_PREFIX_PATH}/StationManager`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/AddStationManager")
    ),
  },
  {
    key: "manpowercompliance",
    path: `${APP_PREFIX_PATH}/manpowercompliance`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/manpowercompliance/ManPowerCompliance")
    ),
  },
  {
    key: "retailcompliance",
    path: `${APP_PREFIX_PATH}/retailcompliance`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/retailOutLetCompliance/RetailOutLetCompliance"
      )
    ),
  },
  {
    key: "schemes",
    path: `${APP_PREFIX_PATH}/user/schemes`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/newScheme/SchemForUser")
    ),
  },
  {
    key: "stc",
    path: `${APP_PREFIX_PATH}/mic/stc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/stc/STCforStation")
    ),
  },
  {
    key: "complain",
    path: `${APP_PREFIX_PATH}/mic/complain`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/ComplainForMIC")
    ),
  },
  {
    key: "techComplaintForMic",
    path: `${APP_PREFIX_PATH}/mic/techcomplain`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/TechComplaintForMic/TechComplaintForMic"
      )
    ),
  },
  {
    key: "userProfile",
    path: `${APP_PREFIX_PATH}/StationProfile/profile/:id`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/users/ViewProfile")
    ),
  },
  {
    key: "NotFound",
    path: `${APP_PREFIX_PATH}/NotFound`,
    component: React.lazy(() => import("views/app-views/dashboards/NotFound")),
  },
  {
    key: "ActivityCalendar",
    path: `${APP_PREFIX_PATH}/activityCalendar/Calendar`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/calendar/CalenderForMIC")
    ),
  },
  {
    key: "ViewTargets",
    path: `${APP_PREFIX_PATH}/ViewTargets`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/saleTarget/SaleTargetForm")
    ),
  },
  {
    key: "Assign Targets",
    path: `${APP_PREFIX_PATH}/AssignTargets`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/saleTarget/AssignTarget")
    ),
  },
  {
    key: "ManPowerComplianceMICReport",
    path: `${APP_PREFIX_PATH}/report/ManPowerComplianceMICReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManPowerComplianceMICReport")
    ),
  },
  {
    key: "roAudit",
    path: `${APP_PREFIX_PATH}/mic/roAudit`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micRoAudit/MICaudit")
    ),
  },
  {
    key: "roAudit1",
    path: `${APP_PREFIX_PATH}/mic/Penalty`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/roPenalty/RoPenaltyForMIC")
    ),
  },
  {
    key: "roauditMAin",
    path: `${APP_PREFIX_PATH}/docs/documentation/audits/:rowid`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/ro-Audit/RoAuditMain")
    ),
  },
  {
    key: "NonOpROReport",
    path: `${APP_PREFIX_PATH}/report/NonOpROReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/NonOpROReport")
    ),
  },
  {
    key: "BankGuaranteeMIC",
    path: `${APP_PREFIX_PATH}/mic/BankGuaranteeMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/bankGurantee/BankGuaranteeMIC")
    ),
  },
  {
    key: "DryoutMICReport",
    path: `${APP_PREFIX_PATH}/report/DryoutMICReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/DryoutMICReport")
    ),
  },
  {
    key: "ROComplianceReportMMIC",
    path: `${APP_PREFIX_PATH}/report/ROComplianceReportMMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ROComplianceReportMMIC")
    ),
  },
  {
    key: "Reports",
    path: `${APP_PREFIX_PATH}/report/AccountsMICReport`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/AccountsMICReport")
    ),
  },
  {
    key: "Reports",
    path: `${APP_PREFIX_PATH}/report`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/report/Reports")
    ),
  },
  {
    key: "SaleReportMIC",
    path: `${APP_PREFIX_PATH}/micReport/SaleReportMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/SaleReportMIC")
    ),
  },
  {
    key: "TechnicalComplaintMIC",
    path: `${APP_PREFIX_PATH}/micReport/TechnicalComplaintMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/TechnicalComplaintMIC")
    ),
  },
  {
    key: "ManningNormsMic",
    path: `${APP_PREFIX_PATH}/micReport/ManningNormsMic`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManningNomsMic")
    ),
  },
  {
    key: "ManningNormsMicReports",
    path: `${APP_PREFIX_PATH}/micReport/ManningNormsMicReports`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/ManningNormsMICReports")
    ),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
  {
    key: "GrowthMIC",
    path: `${APP_PREFIX_PATH}/micReport/GrowthMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/GrowthMIC")
    ),
  },
  {
    key: "MarketShareReportMIC",
    path: `${APP_PREFIX_PATH}/micReport/MarketShareReportMIC`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/reportsForAdmin/MarketShareReportAdmin"
      )
    ),
  },
  {
    key: "DaywiseSalesReportMIC",
    path: `${APP_PREFIX_PATH}/micReport/DaywiseSalesReportMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/DaywiseSalesReportMIC")
    ),
  },
  {
    key: "MonthwiseSalesReportMIC",
    path: `${APP_PREFIX_PATH}/micReport/MonthwiseSalesReportMIC`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/micReport/MonthwiseSalesReportMIC")
    ),
  },
];

export const HrirRoutes = [
  {
    key: "dashboardhrir",
    path: `${APP_PREFIX_PATH}/dashboards/hrir`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/manpowercompliance/ManpowerComplianceHrir"
      )
    ),
  },
  {
    key: "dashboardhrir",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() =>
      import(
        "views/app-views/dashboards/manpowercompliance/ManpowerComplianceHrir"
      )
    ),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
];

export const OmcRoutes = [
  {
    key: "dashboardomc",
    path: `${APP_PREFIX_PATH}/dashboards/omc`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/TechnicalComplaintomc")
    ),
  },
  {
    key: "dashboardomc",
    path: `${APP_PREFIX_PATH}`,
    component: React.lazy(() =>
      import("views/app-views/dashboards/complain/TechnicalComplaintomc")
    ),
  },
  {
    key: "changepass",
    path: `${APP_PREFIX_PATH}/changepass`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login/ChangePassword")
    ),
  },
];
